import script from "./msgCar.vue?vue&type=script&setup=true&name=msgCar&lang=js"
export * from "./msgCar.vue?vue&type=script&setup=true&name=msgCar&lang=js"

import "./msgCar.vue?vue&type=style&index=0&id=1c983427&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c983427"]])

export default __exports__